<script lang="ts">
  import Arrow from "$components/arrow/index.svelte";
  export let content: string = "";

  let showing = false;
  let showButton = false;
  if (content.length > 400) {
    showButton = true;
  }

  function toggleContent() {
    showing = !showing;
  }
</script>

<div class="content-slider">
  <div class={`text-container ${showing ? "active" : ""} `}>{@html content}</div>
  {#if showButton}
    <div class="btn-container">
      <button on:click={toggleContent}>
        <Arrow direction={showing ? "up" : "down"} />
      </button>
    </div>
  {/if}
</div>

<style lang="scss">
  @use "@styles/breakpoint-mixins" as *;
  .content-slider {
    display: grid;
    position: relative;
    .text-container {
      overflow: hidden;
      max-height: 160px;
      transition: max-height 0.5s;
      margin-bottom: 20px;
    }
    :global(.text-container > h2) {
      font-family: var(--secondary-font);
    }

    .btn-container {
      button {
        background: transparent;
        /* background: linear-gradient(to top, rgba(255, 255, 255, 0.5), rgba(255, 0, 0, 0)); */
        border: none;
        color: #000;
      }
    }
    .active {
      max-height: 1500px;
      transition: max-height 0.5s;
    }
  }
</style>
